import { Accordion, AccordionGroup, Text } from 'react-gldn-kit';

import PromoCodeTitle, {
  PromoCodeTitleProps,
} from '../../../PromoCode/PromoCodeActivateModal/components/PromoCodeTitle';

import { EBonusType } from 'components/ui/Bonuses/BonusOnDeposit/types';

import { RAKEBACK_INFO } from './mock';

import styles from './BonusInfo.module.css';

export const BONUS_INFO_RESPONSE: {
  [key in EBonusType]: React.FC<
    Omit<PromoCodeTitleProps, 'title' | 'description'>
  >;
} = {
  [EBonusType.Undefined]: ({
    list,
    specV,
  }: Omit<PromoCodeTitleProps, 'title' | 'description'>) => <></>,
  [EBonusType.Retention]: ({
    list,
    specV,
  }: Omit<PromoCodeTitleProps, 'title' | 'description'>) => <></>,
  [EBonusType.BonusOnDeposit]: ({
    list,
    specV,
  }: Omit<PromoCodeTitleProps, 'title' | 'description'>) => (
    <PromoCodeTitle
      title="bonusCabinet.bonusInfo.main"
      list={list}
      specV={specV}
    />
  ),
  [EBonusType.FreeSpins]: ({
    list,
    specV,
  }: Omit<PromoCodeTitleProps, 'title' | 'description'>) => (
    <PromoCodeTitle
      title="bonusCabinet.bonusInfo.main"
      list={list}
      specV={specV}
    />
  ),
  [EBonusType.RakeBack]: ({
    list,
    specV,
  }: Omit<PromoCodeTitleProps, 'title' | 'description'>) => (
    <>
      <div className={styles.title}>
        <Text idT="bonusCabinet.bonusInfo.main" />
      </div>
      <AccordionGroup>
        <>
          {RAKEBACK_INFO.map(({ title, answer }, idx) => (
            <Accordion
              title={title}
              data={answer}
              key={idx}
              itemTextClasses={styles.answer}
            />
          ))}
        </>
      </AccordionGroup>
    </>
  ),
  [EBonusType.Battle]: ({
    list,
    specV,
  }: Omit<PromoCodeTitleProps, 'title' | 'description'>) => (
    <>
      <div className={styles.title}>
        <Text idT="bonusCabinet.bonusInfo.main" />
      </div>
      <div className={styles.text}>
        <div>
          <Text idT="bonusCabinet.weeklyBattles.1" />
        </div>
        <div>
          <Text idT="bonusCabinet.weeklyBattles.2" />
        </div>
        <div>
          <Text idT="bonusCabinet.weeklyBattles.3" />
        </div>
      </div>
    </>
  ),
  [EBonusType.Monthly]: ({
    list,
    specV,
  }: Omit<PromoCodeTitleProps, 'title' | 'description'>) => <></>,
  [EBonusType.Support]: ({
    list,
    specV,
  }: Omit<PromoCodeTitleProps, 'title' | 'description'>) => <></>,
  [EBonusType.RakeBackBoost]: ({
    list,
    specV,
  }: Omit<PromoCodeTitleProps, 'title' | 'description'>) => <></>,
  [EBonusType.Weekly]: ({
    list,
    specV,
  }: Omit<PromoCodeTitleProps, 'title' | 'description'>) => <></>,
};

export const IGNORED_KEYS = [
  'operationId',
  'timeStamp',
  'promotion',
  'title',
  'endActivationTime',
  'gameId',
  'isActive',
  'rollingTime',
  'fullRolled',
  'value',
  'validFrom',
  'validUntil',
];
